<template>
    <div>
        <div id="nav-space"></div>
        <!-- <nav class="app-navbar" :style="navbarStyle">
            <div class="app-navbar__content row"> //
            <div class="app-navbar__menu-container mx-auto" style="display:block !important;height: auto !important;">
                <router-link class="app-navbar__logo mb-2" style="" to="#" :is="'span'">
                    <template v-if="fs.logo_url == ''">
                        <h1 style="font-size:x-large">LOGO</h1>
                    </template>
<template v-else>
                        <img :src="`${fs.logo_url}`" v-if="fs.logo_url != ''" class="img-responsive my-2"
                            style="margin:0 auto; width : 50%" />
                    </template>
</router-link>
</div>

<div class="app-navbar__center lg5 md4"></div>
</div>//
<div class="app-navbar__shape" :style="shapeStyle"></div>
</nav> -->
    </div>
</template>

<script>
// import fs from "@/config/core.js";
import fs from "@/components/series/fs.js";
import VaIconVuestic from "../../../iconset/VaIconVuestic";
import VaIconMenu from "../../../iconset/VaIconMenu";
import VaIconMenuCollapsed from "../../../iconset/VaIconMenuCollapsed";
import AppNavbarActions from "./components/AppNavbarActions";
import { colorShiftHsl, ColorThemeMixin } from "../../../services/vuestic-ui";

export default {
    name: "app-navbar",
    mixins: [ColorThemeMixin],
    inject: ["contextConfig"],
    components: {
        VaIconVuestic,
        VaIconMenu,
        VaIconMenuCollapsed,
        AppNavbarActions
    },
    props: {
        isTopBar: {
            type: Boolean,
            required: true
        },
        minimized: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            userName: "None",
            fs: fs
        };
    },
    computed: {
        isTopBarProxy: {
            get() {
                return this.isTopBar;
            },
            set(isTopBar) {
                this.$emit("update:isTopBar", isTopBar);
            }
        },
        minimizedProxy: {
            get() {
                return this.minimized;
            },
            set(minimized) {
                this.$emit("update:minimized", minimized);
            }
        },
        navbarStyle() {
            const style = {
                backgroundColor: "white"
            };

            if (this.contextConfig.gradient) {
                style.backgroundColor = colorShiftHsl(this.$themes.secondary, {
                    s: -13,
                    l: 15
                }).css;
            }

            if (this.contextConfig.shadow === "sm") {
                style.boxShadow = !this.isTopBar
                    ? //? "0 2px 3px 0 rgba(52, 56, 85, 0.25)"
                    ""
                    : null;

                style.borderBottom = "1px solid #F5F5F5";
            }
            return style;
        },

        shapeStyle() {
            return {
                borderTopColor: this.contextConfig.gradient
                    ? colorShiftHsl(this.$themes.secondary, {
                        h: -1,
                        s: -11,
                        l: 10
                    }).css
                    : "transparent"
            };
        }
    }
};
</script>

<style lang="scss">
$nav-border-side-width: 3.1875rem;

.app-navbar {
    transition: background-color 0.3s ease;
    /* sidebar's bg color transitions as well -> consistency */
    display: flex;
    padding: 1rem 0rem;
    z-index: 1;

    &__content {
        z-index: 1;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        height: 100%;
        flex: 1 1 auto;
    }

    &__center {
        display: flex;
        margin-left: 3rem;
        justify-content: space-between;
        align-items: center;
    }

    &__text {
        color: $lighter-gray;
    }

    &__button {
        width: 10rem;
        margin: 0 0 0 1rem !important;
        font-weight: bold;

        .va-button__content__icon-left.fa-github {
            font-size: 1.5rem;
        }
    }

    &__menu {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        margin-right: 1.5rem;
    }

    &__menu-container {
        display: flex;
        flex-wrap: nowrap;
        height: 1.5rem;
    }

    &__logo {
        width: 9.5rem;
        height: auto;
        align-items: center;

        & * {
            max-height: 100%;
            max-width: 100%;
            width: 100%;
            height: 100%;
            display: block;
            font-weight: 500;
            line-height: 0.85;
        }
    }

    &__actions {
        justify-content: flex-end;
    }

    &__mailto-link:hover {
        filter: brightness(85%);
    }

    &__shape {
        transition: border-top-color 0.3s ease;
        /* sidebar's bg color transitions as well -> consistency */
        width: 33%;
        max-width: 467px;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        margin: auto;
        border-top: 4.215rem solid transparent; // hardcoded size
        border-left: $nav-border-side-width solid transparent;
        border-right: $nav-border-side-width solid transparent;
        height: 0;
    }

    @include media-breakpoint-down(lg) {
        &__button {
            display: none !important;
        }
    }

    @include media-breakpoint-down(md) {
        &__center {
            display: none !important;
        }
    }

    @include media-breakpoint-down(sm) {
        &__content {
            align-items: flex-end;
        }

        &__actions {
            margin-top: 1.25rem;
            justify-content: space-between;
            width: 100%;
        }

        &__shape {
            display: none;
        }
    }
}
</style>

<style lang="scss" scoped>
@import "../../../sass/speciefied.scss";

.app-navbar__center {
    margin-left: 0px;
}

#nav-space {
    width: 100%;
    height: 7.5px;
    background: #ffa48a;
    border: 0;
}
</style>
